import { CompactUserResponse, UserResponse, UserRole } from '@business/entities/account';

export function getRoleName(role: UserRole) {
  switch (role) {
    case UserRole.admin:
      return 'Admin';
    case UserRole.client:
      return 'Customer';
    case UserRole.user:
      return 'User';
    case UserRole.affiliate:
      return 'Affiliate';
    case UserRole.noLogin:
      return 'No Login';
  }
  return role;
}

export function getRoleColor(role: UserRole) {
  switch (role) {
    case UserRole.admin:
      return 'primary';
    case UserRole.client:
      return 'info';
    case UserRole.user:
      return 'dark';
  }
}

export function getRoles() {
  return [UserRole.user, UserRole.admin, UserRole.client, UserRole.affiliate];
}

export function isStaff(user: UserResponse | CompactUserResponse) {
  return user.role === UserRole.admin || user.role === UserRole.user;
}
